<div
  class="chip"
  [class]="chipClass()"
  [class.icon-only]="iconOnly()"
  [attr.role]="'status'"
  [attr.aria-label]="label()"
>
  @if (iconStart()) {
    <mat-icon class="chip-icon" [class]="iconClass()">
      {{ iconStart() }}
    </mat-icon>
  }
  @if (label()) {
    <span class="chip-label">{{ label() }}</span>
  }
  @if (iconEnd()) {
    <mat-icon class="chip-icon" [class]="iconClass()">{{ iconEnd() }}</mat-icon>
  }
</div>
